// language=GraphQL
export const ALL_CURRENCYOVERRIDES_QUERY = `query Query($withCurrency: Boolean = false) {
  currencyOverrides: travelPricingCurrencyOverrides {
    id
    enabled
    currency @include(if: $withCurrency) {
      id
      name
      symbol
      code
      isDefault
      exchangeRate
      defaultCountries
    }
    exchangeRate
  }
}`

// language=GraphQL
export const SINGLE_CURRENCYOVERRIDE_QUERY = `query Query($id: ID!, $withCurrency: Boolean = false) {
  currencyOverride: travelPricingCurrencyOverride(id: $id) {
    id
    enabled
    currency @include(if: $withCurrency) {
      id
      name
      symbol
      code
      isDefault
      exchangeRate
      defaultCountries
    }
    exchangeRate
  }
}`

// language=GraphQL
export const CREATE_CURRENCYOVERRIDE_MUTATION = `
  mutation Mutation($input: CreateTravelPricingCurrencyOverrideInput, $withCurrency: Boolean = false) {
    currencyOverride: createTravelPricingCurrencyOverride(input: $input) {
      id
      enabled
      currency @include(if: $withCurrency) {
        id
        name
        symbol
        code
        isDefault
        exchangeRate
        defaultCountries
      }
      exchangeRate
    }
  }`

// language=GraphQL
export const UPDATE_CURRENCYOVERRIDE_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingCurrencyOverrideInput, $withCurrency: Boolean = false) {
    currencyOverride: updateTravelPricingCurrencyOverride(input: $input) {
      id
      enabled
      currency @include(if: $withCurrency) {
        id
        name
        symbol
        code
        isDefault
        exchangeRate
        defaultCountries
      }
      exchangeRate
    }
  }`

// language=GraphQL
export const DELETE_CURRENCYOVERRIDE_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingCurrencyOverrideInput) {
    deleteTravelPricingCurrencyOverride(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CURRENCYOVERRIDE_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingCurrencyOverrideInput) {
    forceDeleteTravelPricingCurrencyOverride(input: $input) {
      success
    }
  }`
// language=GraphQL
export const CURRENCYOVERRIDES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false) {
  groupedDependents: travelPricingCurrencyOverrideDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
  }
}`
